// driverLicenseDetailStore.js
'use client';

import useSWR from 'swr';
import FilterBuilder from '../utils/filterBuilder';
import { fleetApi } from '../api/axiosClient';
import { useEffect, useMemo, useState } from 'react';

const getTzParam = () => `?tz=${Math.abs(new Date().getTimezoneOffset() / 60)}`;

const fetcher = async ([url, payload]) => {
  const response = await fleetApi.post(url + getTzParam(), payload);
  return response;
};

export const useDriverLicenseDetailDashboardList = (rowsPerPage = 100) => {
  const [page, setPage] = useState(0);
  const [allData, setAllData] = useState([]);

  const payload = useMemo(() => {
    return new FilterBuilder().setPaging(page * rowsPerPage, rowsPerPage).build();
  }, [page, rowsPerPage]);

  const key = ['/driver-license-detail/dashboard/search', JSON.stringify(payload)];

  const { data, error, isLoading, mutate } = useSWR(key, fetcher, {
    revalidateOnFocus: false,
    shouldRetryOnError: false
  });

  useEffect(() => {
    if (data) {
      if (page === 0) {
        setAllData(data);
      } else {
        setAllData((prev) => [...prev, ...data]);
      }
      if (data.length === rowsPerPage) {
        setPage((p) => p + 1);
      }
    }
  }, [data, page, rowsPerPage]);

  const refetch = async () => {
    setPage(0);
    return mutate();
  };

  return {
    data: allData,
    isLoading: isLoading && allData.length === 0,
    error,
    refetch
  };
};
